// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"6be0b417","395":"6be0b417","626":"80678dc9","967":"6be0b417"}[chunkId] + ".chunk.css";
};